/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './actionTypes';

const initialState = {
  planType: [],
  rebateProgramList: [],
  rebateProgramNameValue: '',
  selectedPlanType: '',
  rebateProgramValue: '',
  errors: [],

  rebateProgramName: '',
  isLoading: false,
  manufacturerList: [],
  outstandingDisputesQuarter: [],
  outstandingDisputesQuarterHeader: [],
  quarterValue: '',
  isAllManufacturersSelected: false,
  allRebateProgram: false,
  exportAllData: {},
  manufacturerSelected: [],
  searchScreenVar: {
    rebateProgramValue: '',
    selectedPlanType: '',
    quarterValue: '',
    allRebateProgram: false,
    rebateProgrameName: '',
    isAllManufacturersSelected: true,
    // scrollDownManufacturers: true,
  },
};
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    // case ActionTypes.GET_REBATE_PROGRAM_OUTSTANDING_DISPUTES_QUARTER:
    //   return { ...state, rebateProgramList: action.payload };
    case ActionTypes.SET_SELECTED_OUTSTANDING_DISPUTES_QUARTER:
      return { ...state, ...action.payload };
    // Manufacturer Grid
    case ActionTypes.GET_MANUFACTURER_LIST_OUTSTANDING_DISPUTES_QUARTER:
      return { ...state, manufacturerList: action.manufacturerList };
    case ActionTypes.IS_LOADING_OUTSTANDING_DISPUTES_QUARTER:
      return { ...state, isLoading: action.isLoading };
    // For Search Screen Header
    case ActionTypes.GET_OUTSTANDING_DISPUTES_QUARTER_HEADER:
      return {
        ...state,
        outstandingDisputesQuarterHeader:
          action.outstandingDisputesQuarterHeader,
      };
    // For Search Screen result
    case ActionTypes.GET_OUTSTANDING_DISPUTES_QUARTER:
      return {
        ...state,
        outstandingDisputesQuarter: action.outstandingDisputesQuarter,
      };
    case ActionTypes.REFRESH_OUTSTANDING_DISPUTE_QUARTER:
      return { ...state, searchScreenVar: initialState.searchScreenVar };
    case ActionTypes.REFRESH_OUTSTANDING_DISPUTE_QUARTER_DISPLAY:
      return { ...state, searchScreenVar: initialState.searchScreenVar };
    case ActionTypes.SET_EXPORT_ALL_PDF_OUTSTANDING_DISPUTES_QUARTER:
      const { data, rebateProgram } = action.payload;
      const exportAllData =
        rebateProgram === 'noData'
          ? {}
          : { ...state.exportAllData, [rebateProgram]: data };

      return {
        ...state,
        exportAllData,
      };
    case ActionTypes.SET_PAGINATION_INDEX_OUTSTANDING_DISPUTES_QUARTER:
      return {
        ...state,
        searchScreenVar: {
          ...state.searchScreenVar,
          countValue: action.payload,
        },
      };
    default:
      return state;
  }
};

export default reducer;
